import api from "@/api";

export default {
    namespaced: true,

    actions: {

        async fetchLocationIssues(context, {page, s, fixed}) {
            const url = `/admin/location-issues?page=${page}&s=${s}&fixed=${fixed}`
            const response = await api.request("get", url);
            return response.data;
        },

        async fixLocationIssue(context, item) {
            const url = `/admin/location-issues/${item.id}/fix`;
            return await api.request('post', url);
        },

        async deleteLocationIssue(context, item) {
            const url = `/admin/location-issues/${item.id}`;
            return await api.request('delete', url);
        },

    }
}
